import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgServiceUnavailable = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 200,
	fill: "none",
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint0_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M175.68 82.68H34.26"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint1_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M51 75.75a2.41 2.41 0 1 0 0-4.83 2.41 2.41 0 0 0 0 4.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint2_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M58.31 75.75a2.41 2.41 0 1 0 0-4.83 2.41 2.41 0 0 0 0 4.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-unknown-accent, #E7E8EB)",
			d: "M43.68 75.75a2.41 2.41 0 1 0 0-4.83 2.41 2.41 0 0 0 0 4.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint3_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M43.68 75.75a2.41 2.41 0 1 0 0-4.83 2.41 2.41 0 0 0 0 4.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#service-unavailable_svg__paint4_linear_4001_8095)",
			d: "M40.8 63.93v-.5zm134.9 65.66-.09.5a.5.5 0 0 0 .4-.12.5.5 0 0 0 .19-.38zm-57.54-9.57.09-.5a.5.5 0 0 0-.2.98zm-3.86 49.28v.5l.14-.02zM33.76 70.48v92.27h1V70.48zm2.06-4.98a7 7 0 0 0-2.06 4.98h1c0-1.6.64-3.14 1.77-4.27zm4.98-2.07c-1.87 0-3.66.75-4.98 2.07l.71.7a6 6 0 0 1 4.27-1.77zm128.34 0H40.8v1h128.34zm4.99 2.07a7 7 0 0 0-4.99-2.07v1c1.6 0 3.15.64 4.28 1.77zm2.07 4.98c0-1.87-.75-3.66-2.07-4.98l-.7.7a6 6 0 0 1 1.77 4.28zm0 59.11V70.5h-1v59.1zm-58.12-9.08 57.53 9.58.17-1-57.53-9.57zm6.23 25c.61-6.7.29-12.87-.74-17.5a20 20 0 0 0-2.09-5.74c-.86-1.44-1.93-2.46-3.2-2.74l-.22.97q1.36.29 2.56 2.29a19 19 0 0 1 1.97 5.43c1 4.52 1.33 10.58.72 17.2zm-9.87 24.27c1.2-.33 2.33-1.28 3.36-2.63s2-3.16 2.87-5.3c1.72-4.3 3.05-10.02 3.64-16.35l-1-.09c-.58 6.26-1.9 11.88-3.57 16.06a22 22 0 0 1-2.73 5.08q-1.47 1.9-2.84 2.27zm-73.63.02h73.5v-1H40.8zm-4.98-2.06a7 7 0 0 0 4.98 2.06v-1a6 6 0 0 1-4.28-1.77zm-2.07-5c0 1.88.74 3.67 2.07 5l.7-.71a6 6 0 0 1-1.77-4.28z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint5_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M190.7 169.3H19.24"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-unknown-accent-mid, #A1A5AD)",
			d: "M102.43 56.73a3.8 3.8 0 0 1 6.56 0l22.19 38.45a3.8 3.8 0 0 1-3.29 5.68H83.51a3.78 3.78 0 0 1-3.29-5.68z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint6_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M102.43 56.73a3.8 3.8 0 0 1 6.56 0l22.19 38.45a3.8 3.8 0 0 1-3.29 5.68H83.51a3.78 3.78 0 0 1-3.29-5.68z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-unknown-accent, #E7E8EB)",
			d: "M105.72 81.83a2.36 2.36 0 0 1-2.36-2.36V47.89a2.36 2.36 0 1 1 4.72 0v31.58a2.4 2.4 0 0 1-2.36 2.36"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint7_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M105.72 81.83a2.36 2.36 0 0 1-2.36-2.36V47.89a2.36 2.36 0 1 1 4.72 0v31.58a2.4 2.4 0 0 1-2.36 2.36"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-unknown-accent, #E7E8EB)",
			d: "M105.72 92.49a2.72 2.72 0 1 0 0-5.43 2.72 2.72 0 0 0 0 5.43"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint8_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M105.72 92.49a2.72 2.72 0 1 0 0-5.43 2.72 2.72 0 0 0 0 5.43"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint9_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m11.69 106.18-.02 13.36"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint10_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M18.36 112.87 5 112.85"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint11_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M132.32 35.52a2.47 2.47 0 1 0 0-4.94 2.47 2.47 0 0 0 0 4.94"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint12_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M194.03 88.06v11.91"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#service-unavailable_svg__paint13_linear_4001_8095)",
			d: "M194.03 105.96a1 1 0 0 0 .94-.6 1 1 0 0 0-.22-1.07.96.96 0 0 0-1.38.03.97.97 0 0 0 0 1.34q.28.27.66.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint14_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M194.03 105.96a1 1 0 0 0 .94-.6 1 1 0 0 0-.22-1.07.96.96 0 0 0-1.38.03.97.97 0 0 0 0 1.34q.28.27.66.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint15_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m118.16 120.02 59.59 9.91c3.42.92 5.4 9.77 4.43 20.3s-4.55 18.92-8.1 19.13l-60.63.06c4.5.05 9.12-10.53 10.36-23.96 1.23-13.3-1.3-24.48-5.65-25.44"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-unknown-accent-mid, #A1A5AD)",
			d: "M94.7 143.44c-1.24-.97-2.41-2.03-3.63-3.02-8.23-6.65-12.48-3.72-9.37 7.41 2.78 9.92-2.54 7.26-11.64 1.6-5.53-3.44-10.2-6.91-13.7-9.16-8.34-5.36-12.77-.13-8.72 10.17 4.54 11.57.4 9.37-10.23 5.62-11.26-3.95-12.52 4.01-5.87 13.25l82.16.09c3.34-.25 6.69-6.27 8.66-14.88-12.58-.15-22.44-7-27.66-11.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint16_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M94.7 143.44c-1.24-.97-2.41-2.03-3.63-3.02-8.23-6.65-12.48-3.72-9.37 7.41 2.78 9.92-2.54 7.26-11.64 1.6-5.53-3.44-10.2-6.91-13.7-9.16-8.34-5.36-12.77-.13-8.72 10.17 4.54 11.57.4 9.37-10.23 5.62-11.26-3.95-12.52 4.01-5.87 13.25l82.16.09c3.34-.25 6.69-6.27 8.66-14.88-12.58-.15-22.44-7-27.66-11.08"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-unknown-accent-mid, #A1A5AD)",
			d: "M63.44 137.55c-1.35 1.67-4.77-.79-7.39-2.83-2.38-1.85-5.39-4.21-4.04-6.12 2.77-3.94 14.28 5.44 11.43 8.95"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint17_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M63.44 137.55c-1.35 1.67-4.77-.79-7.39-2.83-2.38-1.85-5.39-4.21-4.04-6.12 2.77-3.94 14.28 5.44 11.43 8.95"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-unknown-accent-mid, #A1A5AD)",
			d: "M162.23 150.2s-.85 4.73-3.18 4.61c-2.04-.1-2.62-2.85-2.78-4.93zm-17.98-.95s1.73-9.19 6.49-8.94 5.36 7.5 5.53 9.57z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-unknown-accent, #E7E8EB)",
			d: "M118.16 120.02c-6.78-1.13-10.3 16.9-10.94 23.9q-.33 3.52-.3 7.06a39 39 0 0 0 15.47 3.54c3.36-14.55 1.68-33.19-4.23-34.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#service-unavailable_svg__paint18_linear_4001_8095)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M118.16 120.02c-6.78-1.13-10.3 16.9-10.94 23.9q-.33 3.52-.3 7.06a39 39 0 0 0 15.47 3.54c3.36-14.55 1.68-33.19-4.23-34.5"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint0_linear_4001_8095",
				x1: 104.968,
				x2: 104.968,
				y1: 83.531,
				y2: 82.861,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint1_linear_4001_8095",
				x1: 50.999,
				x2: 50.883,
				y1: 75.029,
				y2: 71.797,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint2_linear_4001_8095",
				x1: 58.314,
				x2: 58.198,
				y1: 75.029,
				y2: 71.797,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint3_linear_4001_8095",
				x1: 43.684,
				x2: 43.568,
				y1: 75.029,
				y2: 71.797,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint4_linear_4001_8095",
				x1: 104.978,
				x2: 103.071,
				y1: 153.981,
				y2: 82.709,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint5_linear_4001_8095",
				x1: 104.968,
				x2: 104.968,
				y1: 170.153,
				y2: 169.483,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint6_linear_4001_8095",
				x1: 105.699,
				x2: 104.721,
				y1: 94.018,
				y2: 63.185,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint7_linear_4001_8095",
				x1: 105.719,
				x2: 99.482,
				y1: 76.429,
				y2: 53.817,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint8_linear_4001_8095",
				x1: 105.719,
				x2: 105.589,
				y1: 91.677,
				y2: 88.038,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint9_linear_4001_8095",
				x1: 11.678,
				x2: 11.323,
				y1: 117.554,
				y2: 117.54,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint10_linear_4001_8095",
				x1: 11.678,
				x2: 11.678,
				y1: 112.869,
				y2: 112.856,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint11_linear_4001_8095",
				x1: 132.319,
				x2: 132.201,
				y1: 34.788,
				y2: 31.48,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint12_linear_4001_8095",
				x1: 194.531,
				x2: 191.648,
				y1: 98.199,
				y2: 91.442,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint13_linear_4001_8095",
				x1: 194.075,
				x2: 194.028,
				y1: 105.669,
				y2: 104.369,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint14_linear_4001_8095",
				x1: 194.075,
				x2: 194.028,
				y1: 105.669,
				y2: 104.369,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint15_linear_4001_8095",
				x1: 147.937,
				x2: 147.088,
				y1: 162.069,
				y2: 128.968,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint16_linear_4001_8095",
				x1: 74.927,
				x2: 74.66,
				y1: 164.566,
				y2: 142.778,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint17_linear_4001_8095",
				x1: 57.783,
				x2: 57.569,
				y1: 136.551,
				y2: 129.55,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "service-unavailable_svg__paint18_linear_4001_8095",
				x1: 115.508,
				x2: 113.848,
				y1: 149.379,
				y2: 126.331,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-unknown-grad-from, #434B5C)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-unknown-grad-to, #898E99)"
				})]
			})
		] })
	]
});
export default SvgServiceUnavailable;
